import { render, staticRenderFns } from "./AdminCareerForm.vue?vue&type=template&id=008a640a&"
import script from "./AdminCareerForm.vue?vue&type=script&lang=js&"
export * from "./AdminCareerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports